export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/f5c29e86d3a5b6f06334d35443df7aba.svg";